export default __webpack_public_path__ + "fe34571f28a53d3523564576c57b3aa8.ttf";